export default "__VITE_ASSET__F2nWp1X6__"